import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectLoadedAccount } from '@app/common/store';
import { Account } from '@app/common/models/account';
import { User, UserGroupNames } from 'pl-core-services';

const ALLOWED_GROUPS = [
  UserGroupNames.SERVICE_AND_SUPPORT,
  UserGroupNames.ACCOUNT_MANAGERS,
];

@Injectable()
export class InternalAdminService {
  constructor(private store: Store) {}

  public isInternalAdmin(user: User) {
    return ALLOWED_GROUPS.some((group) => user.groups?.includes(group));
  }

  public getLoadedAccount(): Observable<Account> {
    return this.store.pipe(selectLoadedAccount);
  }

  public getAccountUuid() {
    return sessionStorage.getItem('account_uuid');
  }
}
